module.exports = __webpack_public_path__ + "2f3c4d71367c7c75ba0c9eb1b279d28e.MP3";